import {useContext, useState} from 'react'
import {UserContext} from "#src/context/UserContext";
import {Link} from "react-router-dom";
import {EntityContext} from "#src/context/EntityContext";
import {AddPlanAndFiles} from "#src/components/dialogs/addPlanAndFiles";
import {NewOrderModal} from "#src/components/dialogs/newOrderModal";
import {verifyPermissions} from "#src/helper/getProductSettingsHandler";

export const Home = () => {

    const { user,company } = useContext(UserContext);
    const [openNewOrderModal, setOpenNewOrderModal] = useState(false);
    const [openPlanAndFilesModal, setPlanAndFilesModal] = useState(false);

    var cardData = [];


    if( verifyPermissions(company, "plan") === true) {
        cardData.push({
            name:"XPlan hochladen",
            icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.16699 20.0002V33.3335C7.16699 34.2176 7.51818 35.0654 8.1433 35.6905C8.76842 36.3156 9.61627 36.6668 10.5003 36.6668H30.5003C31.3844 36.6668 32.2322 36.3156 32.8573 35.6905C33.4825 35.0654 33.8337 34.2176 33.8337 33.3335V20.0002M27.167 10.0002L20.5003 3.3335M20.5003 3.3335L13.8337 10.0002M20.5003 3.3335V25.0002" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
            description:"Hinterlegen Sie Ihre Bestandspläne und Betrachten Sie diese im Digitalen XPLAN Viewer",
            link:"addPlan",
            type:"onclick"
        });
    }

    if( verifyPermissions(company, "orders") === true) {
        cardData.push({
            name:"Angebote anfordern",
            icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.4997 13.3335V26.6668M13.833 20.0002H27.1663M37.1663 20.0002C37.1663 29.2049 29.7044 36.6668 20.4997 36.6668C11.2949 36.6668 3.83301 29.2049 3.83301 20.0002C3.83301 10.7954 11.2949 3.3335 20.4997 3.3335C29.7044 3.3335 37.1663 10.7954 37.1663 20.0002Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
            description:"Fordern Sie ein Unverbindliches Angebot für einen Erstellung oder änderung eines XPlans an.",
            link:"addOrder",
            type:"onclick"
        });
    }


    cardData.push({
        name:"Nachrichten-Center",
        icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.5 19.1667C35.5057 21.3665 34.9918 23.5365 34 25.5C32.8241 27.853 31.0162 29.832 28.7791 31.2155C26.5419 32.599 23.9637 33.3324 21.3333 33.3334C19.1336 33.3391 16.9635 32.8252 15 31.8334L5.5 35L8.66667 25.5C7.67489 23.5365 7.16093 21.3665 7.16667 19.1667C7.16768 16.5363 7.90102 13.9581 9.28453 11.721C10.668 9.4838 12.6471 7.67599 15 6.50005C16.9635 5.50827 19.1336 4.99431 21.3333 5.00005H22.1667C25.6406 5.1917 28.9217 6.65798 31.3819 9.11815C33.8421 11.5783 35.3083 14.8595 35.5 18.3334V19.1667Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
        description:"Hier finden Sie Updates zu Ihren Aufträgen sowie angeforderte Angebote",
        link:"/notifications",
    });

    if( verifyPermissions(company, "plan") === true) {
        cardData.push({
            name:"Meine Pläne ",
            icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.83301 28.3335L20.4997 36.6668L37.1663 28.3335M3.83301 20.0002L20.4997 28.3335L37.1663 20.0002M20.4997 3.3335L3.83301 11.6668L20.4997 20.0002L37.1663 11.6668L20.4997 3.3335Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
            description:"Alle Ihre Pläne auf einem Blick",
            link:"/plans",
        });
    }




    if( verifyPermissions(company, "orders") === true) {
        cardData.push({
            name:"Meine Aufträge",
            icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.16699 1.6665H8.83366L13.3003 23.9832C13.4527 24.7505 13.8702 25.4398 14.4796 25.9303C15.089 26.4209 15.8515 26.6815 16.6337 26.6665H32.8337C33.6158 26.6815 34.3784 26.4209 34.9877 25.9303C35.5971 25.4398 36.0146 24.7505 36.167 23.9832L38.8337 9.99984H10.5003M17.167 34.9998C17.167 35.9203 16.4208 36.6665 15.5003 36.6665C14.5798 36.6665 13.8337 35.9203 13.8337 34.9998C13.8337 34.0794 14.5798 33.3332 15.5003 33.3332C16.4208 33.3332 17.167 34.0794 17.167 34.9998ZM35.5003 34.9998C35.5003 35.9203 34.7541 36.6665 33.8337 36.6665C32.9132 36.6665 32.167 35.9203 32.167 34.9998C32.167 34.0794 32.9132 33.3332 33.8337 33.3332C34.7541 33.3332 35.5003 34.0794 35.5003 34.9998Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
            description:"Beauftragen Sie neue XPläne oder lassen Sie bestehende Pläne anpassen",
            link:"/orders",
        },);
    }


    if( verifyPermissions(company, "maps") === true)  {
        cardData.push({
            name:"Meine Karten",
            icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.5 16.6665C35.5 28.3332 20.5 38.3332 20.5 38.3332C20.5 38.3332 5.5 28.3332 5.5 16.6665C5.5 12.6883 7.08035 8.87295 9.8934 6.0599C12.7064 3.24686 16.5218 1.6665 20.5 1.6665C24.4782 1.6665 28.2936 3.24686 31.1066 6.0599C33.9196 8.87295 35.5 12.6883 35.5 16.6665Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.5 21.6665C23.2614 21.6665 25.5 19.4279 25.5 16.6665C25.5 13.9051 23.2614 11.6665 20.5 11.6665C17.7386 11.6665 15.5 13.9051 15.5 16.6665C15.5 19.4279 17.7386 21.6665 20.5 21.6665Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
            description:"Fassen Sie Ihre Pläne zu Digitalen Karten zusammen und veröffentlichen Sie diese.",
            link:"/maps",});
    }


    if( verifyPermissions(company, "ordersTender") === true) {
        cardData.push({
            name:"Gebote abgeben",
            icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.1663 3.3335L18.833 21.6668M37.1663 3.3335L25.4997 36.6668L18.833 21.6668M37.1663 3.3335L3.83301 15.0002L18.833 21.6668" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
            description:"Geben Sie Gebote auf dem Marktplatz ab",
            bg:"#E9FCDE",
            link:"/ordersTender",
        });
    }

    if( verifyPermissions(company, "ordersManagement") === true) {
        cardData.push({
            name:"Bestätigte  Aufträge",
            icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 5V35M8.83333 5H32.1667C34.0076 5 35.5 6.49238 35.5 8.33333V31.6667C35.5 33.5076 34.0076 35 32.1667 35H8.83333C6.99238 35 5.5 33.5076 5.5 31.6667V8.33333C5.5 6.49238 6.99238 5 8.83333 5Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
            description:"Beauftragen Sie neue XPläne oder lassen Sie bestehende Pläne anpassen",
            bg:"#B4E1F6",
            link:"/ordersManagement",
        });
    }

    cardData.push({
        name:"Ökosystem entdecken",
        icon:(<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28 15.6668L13 7.01683M5.95 11.6002L20.5 20.0168L35.05 11.6002M20.5 36.8002V20.0002M35.5 26.6668V13.3335C35.4994 12.749 35.3451 12.1748 35.0526 11.6688C34.76 11.1627 34.3396 10.7424 33.8333 10.4502L22.1667 3.7835C21.6599 3.49093 21.0851 3.33691 20.5 3.33691C19.9149 3.33691 19.3401 3.49093 18.8333 3.7835L7.16667 10.4502C6.66044 10.7424 6.23997 11.1627 5.94744 11.6688C5.6549 12.1748 5.5006 12.749 5.5 13.3335V26.6668C5.5006 27.2514 5.6549 27.8255 5.94744 28.3316C6.23997 28.8376 6.66044 29.2579 7.16667 29.5502L18.8333 36.2168C19.3401 36.5094 19.9149 36.6634 20.5 36.6634C21.0851 36.6634 21.6599 36.5094 22.1667 36.2168L33.8333 29.5502C34.3396 29.2579 34.76 28.8376 35.0526 28.3316C35.3451 27.8255 35.4994 27.2514 35.5 26.6668Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg>),
        description:"Machen Sie mehr aus Ihrem XPlänen.",
        bg:"#D1D5FF",
        link:"/company/integrations",
    });



    const Card = (e) => {

        if(e?.type === "onclick" && e?.link=== "addPlan") {
            return (
                <div onClick={()=> setPlanAndFilesModal(true)} style={{background:e?.bg}} className={"border cursor-pointer border-gray-500 rounded-2xl p-4 lg:p-8"}>
                    {e.icon}
                    <b className={"block mt-4 text-xl font-bold pb-2"}>{e?.name}</b>
                    {e?.description}
                </div>
            );

        } else if(e?.type === "onclick" && e?.link=== "addOrder") {
            return (
                <div onClick={()=> setOpenNewOrderModal(true)} style={{background:e?.bg}} className={"border cursor-pointer border-gray-500 rounded-2xl p-4 lg:p-8"}>
                    {e.icon}
                    <b className={"block mt-4 text-xl font-bold pb-2"}>{e?.name}</b>
                    {e?.description}
                </div>
            );

        } else {
            return (
                <Link to={e?.link} style={{background:e?.bg}} className={"border border-gray-500 rounded-2xl p-4 lg:p-8"}>
                    {e.icon}
                    <b className={"block mt-4 text-xl font-bold pb-2"}>{e?.name}</b>
                    {e?.description}
                </Link>
            );
        }

    }


    console.log("---------------------");
    console.log(openPlanAndFilesModal);
    console.log(openPlanAndFilesModal);

    return (
        <EntityContext.Provider value={{
            openPlanAndFilesModal,
            setPlanAndFilesModal,
            openNewOrderModal,
        }}>
            <div className='mx-auto w-full sm:max-w-7xl'>
                <div
                    className={
                        'text-base m-5 mt-[30px] mb-12 leading-7 text-gray-600'
                    }>
                    <div className='mt-2 flex flex-col sm:flex-row items-center sm:justify-between'>
                        <div className='min-w-0 flex flex-1'>
                            <h2 className='w-full text-2xl truncate sm:mb-0 mb-4 lg:text-3xl textShadow text-center font-normal leading-7 text-gray-900 sm:truncate  sm:tracking-tight'>
                               {(typeof user?.details?.given_name !== "undefined") ? (
                                   <div>Willkommen <span className={"highlighted"}>{user?.details?.given_name}</span></div>
                               ) :"Willkommen" }
                            </h2>
                        </div>
                    </div>
                </div>
                <div className={'grid grid-cols-3 gap-6'}>
                    {cardData.map((e) => {
                        return Card(e);
                    })}
                </div>
                <AddPlanAndFiles/>
                <NewOrderModal openNewOrderModal={openNewOrderModal} setOpenNewOrderModal={setOpenNewOrderModal} />
            </div>
        </EntityContext.Provider>
    );
}
